export default "__VITE_ASSET__CVKQ$Dd4__"